import { commissionGroupApi } from "api/TenantSlug/CommissionGroup/api.ts";
import { useSelectOptions } from "components/UI/Selects/SearchableSelect/hooks/useSelectOptions.ts";

import CommissionGroupDataOptional = App.Data.CommissionGroupDataOptional;

export const useCommissionGroupSelectOptions = () => {
    return useSelectOptions<CommissionGroupDataOptional>({
        apiFunction: (payload) => commissionGroupApi.index(payload),
        dataKey: "commissionGroups",
        cacheKey: "commission-group-select",
        queryParams: {
            filter: { sort: "title", fields: { commission_groups: "title" } },
        },
        mapToOption: (commissionGroup) => ({
            label: commissionGroup.title ?? "",
            value: commissionGroup.id,
        }),
    });
};
